// tslint:disable
export enum PharmacySpecialization {
    /**
     * @description OTHER
     */
    OTH = 0,
    /**
     * @description COMMUNITY RETAIL PHARMACY
     */
    CRP = 1,
    /**
     * @description SPECIALITY PHARMACY
     */
    SPR = 2,
    /**
     * @description COMPOUNDING PHARMACY
     */
    CMP = 3,
    /**
     * @description HOME INFUSED THERAPY PHARMACY
     */
    HIT = 4,
    /**
     * @description CLINIC PHARMACY
     */
    CLP = 5,
    /**
     * @description MAIL ORDER PHARMACY
     */
    MOP = 6,
    /**
     * @description MANAGED CARE ORGANIZATION
     */
    MCO = 7,
    /**
     * @description INFUSION THERAPY
     */
    IFT = 8,
    /**
     * @description PRIMARY CARE
     */
    PRC = 9,
    /**
     * @description NURSING FACILITY SUPPLIES
     */
    NFS = 10,
}
